export default __webpack_public_path__ + "static/media/Malika_Chopra_AHV_In_Moms_We_Trust.24230f6c.jpg";